import type { ComponentProps } from 'react';

import { cn } from '@/shared/ui/cn';

/**
 * Grade dos campos de um diálogo (UUX §14): uma coluna; duas quando o diálogo `form` passa de ~768 px.
 * Só o campo simples (`data-slot="form-field"`) divide a linha. Texto longo, lista de caixas, aviso,
 * tabela, título e qualquer outro bloco ocupam a linha toda. `data-span="full"` força a linha toda e
 * `data-span="half"` deixa um bloco dividir a linha.
 */
export function FieldGrid({ className, ...props }: ComponentProps<'div'>) {
  return (
    <div
      data-slot="field-grid"
      className={cn(
        'grid min-w-0 gap-4 @min-[45rem]/dialog:grid-cols-2 [&>*]:col-span-full [&>*]:min-w-0',
        '[&>[data-slot=form-field]]:col-span-1 [&>[data-span=half]]:col-span-1',
        '[&>[data-slot=form-field]:has(textarea)]:col-span-full [&>fieldset[data-slot=form-field]]:col-span-full [&>[data-span=full]]:col-span-full!',
        className,
      )}
      {...props}
    />
  );
}
